import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import { langState, langText } from "../../recoil/lang";
import { PRODUCT_TYPE_EXTENSION } from "../../recoil/type";
import "../../styles/CustomModal.css";
import { cancelAudio } from "../../utils/Audio";

let cancelTimer: any;

const OrderCancelModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  cancel_description: string;
  order_category: number;
}) => {
  const navigate = useNavigate();
  const lang = useRecoilValue<number>(langState);

  const playCancelAudio = () => {
    if (cancelAudio) {
      cancelTimer = setTimeout(() => {
        cancelAudio.currentTime = 0;
        cancelAudio.play();
      }, 5000);
    }
  };

  const navigateStatus = () => {
    onCloseModal();
    if (oProps.order_category !== PRODUCT_TYPE_EXTENSION) {
      navigate("/status");
    }
  };

  const onCloseModal = () => {
    oProps.setVisible(false);
    LogController.click({
      path: "OrderCancelModal",
      params: "cancel",
      params2: "사용자가 주문취소 모달 닫음",
    });
  };

  useEffect(() => {
    clearTimeout(cancelTimer);
    cancelTimer = null;
  }, []);

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "OrderCancelModal",
        params: "cancel",
        params2: "주문취소 모달 열림",
      });

      if (cancelAudio) {
        cancelAudio.currentTime = 0;
        cancelAudio.play();
        cancelAudio.addEventListener("ended", playCancelAudio);
      } else {
        clearTimeout(cancelTimer);
        cancelTimer = null;
      }
      return () => {
        cancelAudio.removeEventListener("ended", playCancelAudio);
      };
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "arrivalModalOverlay",
        modal: "arrivalModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cancel_red.svg`}
            alt="ic"
          />
          <div>
            {oProps.order_category === PRODUCT_TYPE_EXTENSION ? (
              <p className="titleFont">{`${langText.orderCancelModal_title_extension[lang]}`}</p>
            ) : (
              <p className="titleFont">{`${langText.orderCancelModal_title[lang]}`}</p>
            )}
            {/* <p className="titleFont">{`${
              langText.orderCancelModal_reason[lang]
            }: ${contentName(oProps.cancel_description, lang)}`}</p> */}
          </div>
          {oProps.order_category === PRODUCT_TYPE_EXTENSION &&
            oProps.cancel_description.length > 0 && (
              <div className="content">
                <h2>{oProps.cancel_description}</h2>
              </div>
            )}
          <div className="confirmButton" onClick={navigateStatus}>
            {oProps.order_category === PRODUCT_TYPE_EXTENSION
              ? `${langText.button_confirm[lang]}`
              : `${langText.orderCancelModal_button_submit[lang]}`}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrderCancelModal;

const Style = styled.div`
  img {
    padding-bottom: 10px;
  }
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 8%;
    width: 100%;
    height: 100%;
  }
  .titleFont {
    width: 100%;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 0;
    white-space: pre;
  }
  .content {
    padding: 16px 0;
    h2 {
      font-size: 28px;
      line-height: 32px;
      font-weight: 600;
      color: #ff4a4a;
      word-break: break-all;
    }
  }
  .confirmButton {
    width: 90%;
    margin-top: 20px;
    padding: 16px;
    background: #ff4a4a;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }
`;
